export const FHS = {
    "data": {
        "mainMenu": [
            {
                "__typename": "section_Entry",
                "id": "115",
                "title": "About",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "305",
                        "title": "About FHS",
                        "navUrl": "/about-fhs"
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "307",
                        "title": "ESG Impact",
                        "navUrl": "/esg"
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "309",
                        "title": "Additional Marketing Opportunities",
                        "navUrl": "/fhs-marketing-opportunities"
                    }
                ]
            },
            {
                "__typename": "navigation_Entry",
                "id": "311",
                "title": "Content Library",
                "navUrl": "/content-library",
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "313",
                "title": "Award Winners",
                "navUrl": "/award-winners",
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "315",
                "title": "FHS Club",
                "navUrl": "/fhs-club",
                "children": []
            }
        ]
    }
}

export const FHS_WORLD = {
    "data": {
        "mainMenu": [
            {
                "__typename": "navigation_Entry",
                "id": "73",
                "title": "About",
                "navUrl": "/world",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "135",
                        "title": "About FHS World",
                        "navUrl": "/world/about-fhs-world",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "139",
                        "title": "Why Attend",
                        "navUrl": "/world/why-attend",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "141",
                        "title": "Travel & Accommodation",
                        "navUrl": "/world/venue",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "143",
                        "title": "Sustainability",
                        "navUrl": "/world/sustainability",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "145",
                        "title": "Virtual Tour",
                        "navUrl": "https://my.matterport.com/show/?m=DaYm3aXzc6n&ss=103&sr=1.79,.48",
                        "target": true
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "147",
                        "title": "Award Winners",
                        "navUrl": "/world/award-winners",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "sfd2hnj",
                        "title": "Content Library",
                        "navUrl": "/world/content-library",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "148",
                        "title": "Contact Us",
                        "navUrl": "/world/contact-us",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "12137",
                "title": "Investors",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "23556666777",
                        "title": "Investors",
                        "navUrl": "/world/investors",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "23556666777",
                        "title": "FHS Dealroom",
                        "navUrl": "/world/fhs-dealroom",
                        "target": false
                    },
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "117",
                "title": "Programme",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "75",
                        "title": "Agenda",
                        "navUrl": "/world/agenda",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "149",
                        "title": "Schedule at a Glance",
                        "navUrl": "/world/schedule-at-a-glance",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "104",
                        "title": "Speakers",
                        "navUrl": "/world/speakers",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "151",
                        "title": "Advisory Board",
                        "navUrl": "/world/advisory-board",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "131",
                "title": "Event Features",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "159",
                        "title": "FHS Living",
                        "navUrl": "/world/living",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "163",
                        "title": "Country Pavilions",
                        "navUrl": "/world/country-pavilions",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "165",
                        "title": "Projects & Investment Opportunities",
                        "navUrl": "/world/projects",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "167",
                        "title": "Startup Zone",
                        "navUrl": "/world/startup-zone",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "169",
                        "title": "Networking Receptions",
                        "navUrl": "/world/networking-receptions",
                        "target": false
                    },
                    // {
                    //     "__typename": "navigation_Entry",
                    //     "id": "171",
                    //     "title": "Happy Hour Networking",
                    //     "navUrl": "/world/happy-hour",
                    //     "target": false
                    // },
                    // {
                    //     "__typename": "navigation_Entry",
                    //     "id": "173",
                    //     "title": "Themed Socials",
                    //     "navUrl": "/world/themed-socials",
                    //     "target": false
                    // },
                    {
                        "__typename": "navigation_Entry",
                        "id": "175",
                        "title": "FHS Women Power",
                        "navUrl": "/world/fhswomenpower",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "177",
                        "title": "Sports & Wellness",
                        "navUrl": "/world/sports",
                        "target": false
                    },
                    // {
                    //     "__typename": "navigation_Entry",
                    //     "id": "159",
                    //     "title": "FHS Gathering: Business Unusual",
                    //     "navUrl": "/world/business-unusual-how-are-we-coping",
                    //     "target": false
                    // },
                    {
                        "__typename": "subsection_Entry",
                        "id": "179",
                        "title": "Awards",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "181",
                                "title": "Future Leader Award",
                                "navUrl": "/world/future-leader-award",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "183",
                                "title": "Leadership Award",
                                "navUrl": "/world/leadership-award",
                                "target": false
                            },
                            // {
                            //     "__typename": "navigation_Entry",
                            //     "id": "185",
                            //     "title": "Impact Leader Award",
                            //     "navUrl": "/world/impact-leader-award",
                            //     "target": false
                            // }
                        ]
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "119",
                "title": "Partnership",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "106",
                        "title": "Partners",
                        "navUrl": "/world/partners",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "155",
                        "title": "Why Partner?",
                        "navUrl": "/world/why-partner",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "519",
                "title": "Editions",
                "children": [
                    {
                        "__typename": "subsection_Entry",
                        "id": "523",
                        "title": "2025",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "525",
                                "title": "Agenda",
                                "navUrl": "/world/2025/agenda",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "527",
                                "title": "Speakers",
                                "navUrl": "/world/2025/speakers",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "529",
                                "title": "Partners",
                                "navUrl": "/world/2025/partners",
                                "target": false
                            }
                        ]
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "623",
                        "title": "2024",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "625",
                                "title": "Agenda",
                                "navUrl": "/world/2024/agenda",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "627",
                                "title": "Speakers",
                                "navUrl": "/world/2024/speakers",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "629",
                                "title": "Partners",
                                "navUrl": "/world/2024/partners",
                                "target": false
                            }
                        ]
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "523",
                        "title": "2023",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "525",
                                "title": "Agenda",
                                "navUrl": "/world/2023/agenda",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "527",
                                "title": "Speakers",
                                "navUrl": "/world/2023/speakers",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "529",
                                "title": "Partners",
                                "navUrl": "/world/2023/partners",
                                "target": false
                            }
                        ]
                    },
                ]
            },
        ],
        "event": {
            "id": "2",
            "title": "FHS World",
            "venue": "Madinat Jumeirah, Dubai",
            "startDate": "2026-09-29T07:00:00+00:00",
            "endDate": "2026-10-01T07:00:00+00:00",
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-World/world.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Here",
                    "hyperlink": "/world/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/world/why-partner#partner-form",
                    "openInNewWindow": false
                }
            ]
        }
    }
}

export const FHS_SA = {
    "data": {
        "mainMenu": [
            {
                "__typename": "section_Entry",
                "id": "187",
                "title": "About",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "189",
                        "title": "About Us",
                        "navUrl": "/sa/about-fhs-saudi",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "193",
                        "title": "Why Attend",
                        "navUrl": "/sa/why-attend",
                        "target": false
                    },
                    // {
                    //     "__typename": "navigation_Entry",
                    //     "id": "195",
                    //     "title": "Networking",
                    //     "navUrl": "/sa/networking",
                    //     "target": false
                    // },
                    {
                        "__typename": "navigation_Entry",
                        "id": "197",
                        "title": "Sustainability",
                        "navUrl": "/sa/sustainability",
                        "target": false
                    },
                    // {
                    //     "__typename": "navigation_Entry",
                    //     "id": "199",
                    //     "title": "Travel Guide",
                    //     "navUrl": "/sa/travel-guide",
                    //     "target": false
                    // },
                    {
                        "__typename": "subsection_Entry",
                        "id": "223",
                        "title": "Content Library",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "225",
                                "title": "Podcasts",
                                "navUrl": "/sa/content-library/category/podcast",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "227",
                                "title": "Press Room",
                                "navUrl": "/sa/content-library/category/press-room",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "229",
                                "title": "Industry News",
                                "navUrl": "/sa/content-library/category/industry-news",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "23676543",
                                "title": "Reports",
                                "navUrl": "/sa/content-library/category/reports",
                                "target": false
                            }
                        ]
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "243",
                        "title": "Loyalty Programme",
                        "navUrl": "/fhs-club",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "201",
                        "title": "Contact Us",
                        "navUrl": "/sa/contact-us",
                        "target": false
                    }
                ]
            },
            {
               "__typename": "section_Entry",
                "id": "187",
                "title": "Investors",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "191",
                        "title": "Investors",
                        "navUrl": "/sa/investors",
                        "children": []
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "23556666777",
                        "title": "FHS Dealroom",
                        "navUrl": "/sa/fhs-dealroom",
                        "target": false
                    },
                ] 
            },
            {
                "__typename": "section_Entry",
                "id": "121",
                "title": "Programme",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "98",
                        "title": "Agenda",
                        "navUrl": "/sa/agenda",
                        "target": false
                    },
                    // {
                    //     "__typename": "navigation_Entry",
                    //     "id": "203",
                    //     "title": "Schedule at a Glance",
                    //     "navUrl": "/sa/agenda-at-a-glance",
                    //     "target": false
                    // },
                    {
                        "__typename": "navigation_Entry",
                        "id": "205",
                        "title": "Themes",
                        "navUrl": "/sa/themes",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "102",
                        "title": "Speakers",
                        "navUrl": "/sa/speakers",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "207",
                        "title": "Advisory Board",
                        "navUrl": "/sa/advisory-board",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "123",
                "title": "Partnership",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "100",
                        "title": "2026 Partners",
                        "navUrl": "/sa/partners",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "213",
                        "title": "Why Partner?",
                        "navUrl": "/sa/why-partner",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "213dsgntewe",
                        "title": "Become a Partner",
                        "navUrl": "/sa/become-a-partner",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "215",
                        "title": "Floor Plan",
                        "navUrl": "https://floorplan.live/interactive/shows/4222/views/3/plan",
                        "target": true
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "217",
                        "title": "3D Virtual Tour",
                        "navUrl": "https://my.matterport.com/show/?m=n62kHSDpDKm",
                        "target": true
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "219",
                "title": "Event Features",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "221",
                        "title": "Webinar",
                        "navUrl": "/sa/webinar",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "237382",
                        "title": "FHS Startup Zone",
                        "navUrl": "/sa/startup-den",
                        "target": false
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "223",
                        "title": "Awards",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "225",
                                "title": "Leadership Award",
                                "navUrl": "/sa/leadership-award",
                                "target": false
                            },
                        ]
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "231",
                        "title": "Experiences",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "235",
                                "title": "Networking",
                                "navUrl": "/sa/networking",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "237",
                                "title": "Sports & Wellness",
                                "navUrl": "/sa/sports-and-wellness",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "239",
                                "title": "FHSWomenPower",
                                "navUrl": "/sa/fhswomenpower",
                                "target": false
                            }
                        ]
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "519",
                "title": "Editions",
                "children": [
                    {
                        "__typename": "subsection_Entry",
                        "id": "523",
                        "title": "2025",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "525",
                                "title": "Agenda",
                                "navUrl": "/sa/2025/agenda",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "527",
                                "title": "Speakers",
                                "navUrl": "/sa/2025/speakers",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "529",
                                "title": "Partners",
                                "navUrl": "/sa/2025/partners",
                                "target": false
                            }
                        ]
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "623",
                        "title": "2024",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "625",
                                "title": "Agenda",
                                "navUrl": "/sa/2024/agenda",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "627",
                                "title": "Speakers",
                                "navUrl": "/sa/2024/speakers",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "629",
                                "title": "Partners",
                                "navUrl": "/sa/2024/partners",
                                "target": false
                            }
                        ]
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "523",
                        "title": "2023",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "525",
                                "title": "Agenda",
                                "navUrl": "/sa/2023/agenda",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "527",
                                "title": "Speakers",
                                "navUrl": "/sa/2023/speakers",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "529",
                                "title": "Partners",
                                "navUrl": "/sa/2023/partners",
                                "target": false
                            }
                        ]
                    },
                ]
            },
        ],
        "event": {
            "id": "2",
            "title": "FHS Saudi Arabia",
            "venue": "Mandarin Oriental Al Faisaliah, Riyadh",
            "startDate": "2026-04-20T07:00:00+00:00",
            "endDate": "2026-04-22T07:00:00+00:00",
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-Saudi-Arabia/saudi-arabia.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Interest for 2027",
                    "hyperlink": "/sa/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/sa/become-a-partner",
                    "openInNewWindow": false
                }
            ]
        }
    }
}

export const FHS_AFRICA = {
    "data": {
        "mainMenu": [
            {
                "__typename": "section_Entry",
                "id": "245",
                "title": "About",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "247",
                        "title": "About FHS Africa",
                        "navUrl": "/africa/about-fhs-africa",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "249",
                        "title": "Travel & Accommodation",
                        "navUrl": "/africa/travel-and-accommodation",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "24967uj",
                        "title": "Explore Uganda",
                        "navUrl": "/africa/explore-uganda",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "274",
                        "title": "Content Library",
                        "navUrl": "/africa/content-library",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "253",
                        "title": "Contact Us",
                        "navUrl": "/africa/contact-us",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "navigation_Entry",
                "id": "251",
                "title": "Investors",
                "navUrl": "/africa/investors",
                "children": []
            },
            {
                "__typename": "section_Entry",
                "id": "125",
                "title": "Programme",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "111",
                        "title": "2026 Agenda",
                        "navUrl": "/africa/agenda",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "257",
                        "title": "Awards",
                        "navUrl": "/africa/ahif-awards",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "94",
                        "title": "2026 Speakers",
                        "navUrl": "/africa/speakers",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "263",
                        "title": "Advisory Board",
                        "navUrl": "/africa/advisory-board",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "127",
                "title": "Partnership",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "268",
                        "title": "Why Partner",
                        "navUrl": "/africa/why-partner",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "109",
                        "title": "2027 Partners",
                        "navUrl": "/africa/partners",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "270",
                "title": "Event Features",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "27s2",
                        "title": "Networking Opportunities",
                        "navUrl": "/africa/networking",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "272",
                        "title": "FHS Dealroom",
                        "navUrl": "/africa/fhs-dealroom",
                        "target": false
                    }
                ]
            }
        ],
        "event": {
            "id": "2",
            "title": "FHS Africa",
            "venue": "Speke Resort Munyonyo, Kampala, Uganda",
            "startDate": "2026-03-31T07:00:00+00:00",
            "endDate": "2026-04-01T07:00:00+00:00",
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-Africa/africa.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Here",
                    "hyperlink": "/africa/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/africa/partner-with-fhs-africa-2027",
                    "openInNewWindow": false
                },
            ]
        }
    }
}

export const FHS_EGYPT = {
    "data": {
        "mainMenu": [
            {
                "__typename": "navigation_Entry",
                "id": "fgh35tjymnbbb",
                "title": "About",
                "navUrl": null,
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "281",
                        "title": "About FHS Egypt",
                        "navUrl": "/egypt/about-fhs-egypt",
                        "target": false
                    },
                    {
                        "__typename": "subsection_Entry",
                        "id": "223",
                        "title": "Content Library",
                        "children": [
                            {
                                "__typename": "navigation_Entry",
                                "id": "225",
                                "title": "Podcasts",
                                "navUrl": "/egypt/content-library/category/podcast",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "227",
                                "title": "Press Room",
                                "navUrl": "/egypt/content-library/category/press-room",
                                "target": false
                            },
                            {
                                "__typename": "navigation_Entry",
                                "id": "235788",
                                "title": "Reports",
                                "navUrl": "/egypt/content-library/category/reports",
                                "target": false
                            }
                        ]
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "283",
                        "title": "Contact Us",
                        "navUrl": "/egypt/contact-us",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "285",
                "title": "Programme",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "287",
                        "title": "Agenda",
                        "navUrl": "/egypt/agenda",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "289",
                        "title": "Speakers",
                        "navUrl": "/egypt/speakers",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "289sdffds",
                        "title": "Webinar",
                        "navUrl": "/egypt/webinar",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "291",
                "title": "Partnership",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "293",
                        "title": "Why Partner?",
                        "navUrl": "/egypt/why-partner",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "295",
                        "title": "Partners and Supporters",
                        "navUrl": "/egypt/partners",
                        "target": false
                    }
                ]
            },
            {
                "__typename": "section_Entry",
                "id": "297",
                "title": "Event Features",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "299",
                        "title": "FHS Living",
                        "navUrl": "/egypt/living",
                        "target": false
                    }
                ]
            }
        ],
        "event": {
            "id": "2",
            "title": "FHS Egypt",
            "venue": "Sofitel Downtown Cairo Nile",
            "startDate": "2026-11-10T08:00:00+00:00",
            "endDate": "2026-11-11T08:00:00+00:00",
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-World/world.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Here",
                    "hyperlink": "/egypt/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/egypt/forms/become-a-partner",
                    "openInNewWindow": false
                }
            ]
        }
    }
}


export const FHS_LIVING = {
    "data": {
        "mainMenu": [
            {
                "__typename": "section_Entry",
                "id": "sfgh455jj",
                "title": "About",
                "children": [
                    {
                        "__typename": "navigation_Entry",
                        "id": "52sfhghs",
                        "title": "About FHS Living",
                        "navUrl": "/living/about",
                        "target": false
                    },
                    {
                        "__typename": "navigation_Entry",
                        "id": "dfghe5yj",
                        "title": "Content Library",
                        "navUrl": "/living/content-library",
                        "target": false
                    },
                ]
            },
            {
                "__typename": "navigation_Entry",
                "id": "356786",
                "title": "Why Now?",
                "navUrl": '/living/why-now',
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "345jt",
                "title": "Programme",
                "navUrl": '/living/programme',
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "26549",
                "title": "Founding Advisors",
                "navUrl": '/living/founding-advisors',
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "345ujj",
                "title": "Partners",
                "navUrl": '/living/partners',
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "ffdghertj",
                "title": "Contact Us",
                "navUrl": '/living/contact-us',
                "children": []
            },
        ],
        "event": {
            "id": "122",
            "title": "FHS Living",
            "venue": "",
            "startDate": "",
            "endDate": "",
            "seoImage": [
                {
                    "url": ""
                }
            ],
            "metaTitle": "FHS Living | Feb 2027, Paris | Founding Edition",
            "metaDescription": "Addressing the growing 'lanyard fatigue' of the European hospitality conferencing market",
            "headerCtas": [
                {
                    "label": "Purchase Pass",
                    "hyperlink": "/living/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Download Brochure",
                    "hyperlink": "/living/register-interest",
                    "openInNewWindow": false
                },
            ]
        }
    }
}

// LIVING sub-events


export const LIVING_FHS_WORLD = {
    "data": {
        "mainMenu": [
            {
                "__typename": "navigation_Entry",
                "id": "etrhh35",
                "title": "About",
                "navUrl": "/world/living",
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "werhjfw",
                "title": "Agenda",
                "navUrl": "/world/living/agenda",
                "children": []
            },
            
        ],
        "event": {
            "id": "2",
            "title": "FHS Living at FHS World",
            "venue": "Madinat Jumeirah, Dubai",
            "startDate": "2026-10-01T07:00:00+00:00",
            "endDate": null,
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-World/world.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Here",
                    "hyperlink": "/world/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/world/why-sponsor#partner-form",
                    "openInNewWindow": false
                }
            ]
        }
    }
}

export const LIVING_FHS_SA = {
    "data": {
        "mainMenu": [
            {
                "__typename": "navigation_Entry",
                "id": "2456346u",
                "title": "About",
                "navUrl": "/sa/living",
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "ngdrtyh",
                "title": "Agenda",
                "navUrl": "/sa/living/agenda",
                "children": []
            },
            
        ],
        "event": {
            "id": "2",
            "title": "FHS Living at FHS World",
            "venue": "Madinat Jumeirah, Dubai",
            "startDate": "2026-10-01T07:00:00+00:00",
            "endDate": null,
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-World/sa.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Here",
                    "hyperlink": "/sa/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/sa/why-sponsor#partner-form",
                    "openInNewWindow": false
                }
            ]
        }
    }
}

export const LIVING_FHS_EGYPT = {
    "data": {
        "mainMenu": [
            {
                "__typename": "navigation_Entry",
                "id": "279",
                "title": "About",
                "navUrl": "/egypt/living",
                "children": []
            },
            {
                "__typename": "navigation_Entry",
                "id": "dfghterthm",
                "title": "Agenda",
                "navUrl": "/egypt/agenda?session=UGxhbm5pbmdfNDUzNTk0Ng",
                "children": []
            },
            
        ],
        "event": {
            "id": "2",
            "title": "FHS Living at FHS egypt",
            "venue": "Madinat Jumeirah, Dubai",
            "startDate": "2026-10-01T07:00:00+00:00",
            "endDate": null,
            "seoImage": [
                {
                    "url": "https://cms.thebench.test/assets/img/events/FHS-egypt/egypt.jpg"
                }
            ],
            "metaTitle": null,
            "metaDescription": null,
            "headerCtas": [
                {
                    "label": "Register Here",
                    "hyperlink": "/egypt/purchase-pass",
                    "openInNewWindow": false
                },
                {
                    "label": "Become a Partner",
                    "hyperlink": "/egypt/why-sponsor#partner-form",
                    "openInNewWindow": false
                }
            ]
        }
    }
}